import { createFileRoute } from '@tanstack/react-router';

import { SiteSubjectsPage } from '@/features/owner/site/SiteSubjectsPage';

export const Route = createFileRoute('/_authed/owner/site/subjects')({
  component: SiteSubjectsPage,
});
